import StructuredEventProperty from './StructuredEventProperty';

export default class AdImpressionEventProperty extends StructuredEventProperty {
  static override readonly type: number = 8;
  static override readonly label: string = 'AdImpression event property';
  static override readonly indexProps = [
    { index: 1, label: 'impressionId' },
    { index: 2, label: 'costModel' },
    { index: 3, label: 'cost' },
    { index: 4, label: 'targetUrl' },
    { index: 5, label: 'bannerId' },
    { index: 6, label: 'zoneId' },
    { index: 7, label: 'advertiserId' },
    { index: 8, label: 'campaignId' },
  ];
}
